import React from 'react';
import { PhoneCall, ClipboardList, Wrench, ThumbsUp, ArrowRight, Clock } from 'lucide-react';
import { motion } from 'framer-motion';
export function HowItWorks() {
  const steps = [{
    icon: PhoneCall,
    title: 'Call or Book Online',
    desc: 'Call 0418 381 988 or submit our quick form. For emergencies, we respond as fast as possible.',
    time: '2 mins'
  }, {
    icon: ClipboardList,
    title: 'Upfront Quote, No Surprises',
    desc: 'We assess the job and give you a clear, fixed price before any work begins. No hidden extras.',
    time: 'Same day'
  }, {
    icon: Wrench,
    title: 'Expert Service, Same Day',
    desc: 'Our licensed electricians arrive on time, work safely, and complete most standard jobs same-day.',
    time: 'Done in hours'
  }, {
    icon: ThumbsUp,
    title: 'Your Complete Satisfaction',
    desc: "We test everything, clean up, and don't leave until you're 100% happy. That's the Completely Electrical Guarantee.",
    time: '100% satisfied'
  }];
  return <section className="py-20 lg:py-28 bg-white" data-id="element-354">
      <div className="max-w-7xl mx-auto px-4" data-id="element-355">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-356">
          <span className="text-accent font-bold tracking-wider uppercase text-sm mb-3 block" data-id="element-357">
            Simple Process
          </span>
          <h2 className="text-4xl md:text-5xl font-heading font-extrabold text-navy mb-6 tracking-tighter" data-id="element-358">
            How It Works
          </h2>
          <p className="text-lg text-slate leading-relaxed" data-id="element-359">
            Getting your electrical issues sorted shouldn't be complicated. Four
            simple steps from first call to job done.
          </p>
        </div>

        <div className="relative max-w-5xl mx-auto" data-id="element-360">
          {/* Connecting Line (Desktop) */}
          <div className="hidden md:block absolute top-12 left-[12%] right-[12%] h-1 bg-gradient-to-r from-accent/20 via-accent to-accent/20 z-0 rounded-full overflow-hidden bg-[length:200%_100%] animate-shimmer" data-id="element-361"></div>

          <div className="grid md:grid-cols-4 gap-12 relative z-10" data-id="element-362">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="text-center relative group" data-id="element-363">
                <div className="w-24 h-24 mx-auto bg-white border-4 border-cream rounded-full flex items-center justify-center mb-6 relative z-10 group-hover:border-accent transition-colors shadow-lg" data-id="element-364">
                  <div className="absolute -top-4 -right-4 w-10 h-10 bg-accent rounded-full flex items-center justify-center font-extrabold text-white text-lg shadow-md border-2 border-white" data-id="element-365">
                    {index + 1}
                  </div>
                  <step.icon className="w-10 h-10 text-navy group-hover:text-accent transition-colors" data-id="element-366" />
                </div>

                <div className="inline-flex items-center gap-1.5 bg-accent/10 text-accent px-2.5 py-1 rounded-full text-[11px] font-extrabold uppercase tracking-wider mb-3" data-id="element-367">
                  <Clock className="w-3 h-3" data-id="element-368" />
                  {step.time}
                </div>

                <h3 className="text-lg font-heading font-extrabold text-navy mb-3" data-id="element-369">
                  {step.title}
                </h3>
                <p className="text-slate text-sm leading-relaxed" data-id="element-370">
                  {step.desc}
                </p>

                {index < steps.length - 1 && <div className="md:hidden flex justify-center mt-8" data-id="element-371">
                    <div className="w-px h-12 bg-gradient-to-b from-accent to-transparent" data-id="element-372"></div>
                  </div>}
              </motion.div>)}
          </div>
        </div>

        {/* Micro-CTA */}
        <div className="text-center mt-14" data-id="element-373">
          <p className="text-slate font-bold mb-4" data-id="element-374">
            Most jobs quoted promptly and completed same-day.
          </p>
          <a href="#quote" className="inline-flex items-center gap-2 bg-accent hover:bg-accent-600 text-white px-8 py-4 rounded-xl font-extrabold text-lg transition-all shadow-lg hover:-translate-y-1" data-id="element-375">
            Start With a Free Quote
            <ArrowRight className="w-5 h-5" data-id="element-376" />
          </a>
        </div>
      </div>
    </section>;
}